/* Auth */
export const SET_APIS = "SET_APIS";
export const SET_BUSINESS_ID = "SET_BUSINESS_ID";
export const SET_ENVIRONMENT = "SET_ENVIRONMENT";
export const SET_LOGIN_URL = "SET_LOGIN_URL";
export const SET_ORIGIN = "SET_ORIGIN";
export const SET_TOKEN = "SET_TOKEN";

/* UI */
export const SET_DEFAULT_PAGE_SIZE = "SET_DEFAULT_PAGE_SIZE";
export const SET_LEFT_DRAWER = "SET_LEFT_DRAWER";
export const SET_PAGE_SUBTITLE = "SET_PAGE_SUBTITLE";
export const SET_PAGE_TITLE = "SET_PAGE_TITLE";

/* Snackbar */
export const DEQUEUE_MESSAGE = "DEQUEUE_MESSAGE";
export const ENQUEUE_MESSAGE = "ENQUEUE_MESSAGE";
export const RESET_SNACKBAR = "RESET_SNACKBAR";
export const UPDATE_MESSAGE = "UPDATE_MESSAGE";

/* FAQ */
export const CLEAR_CONNECTIONS = "CLEAR_CONNECTIONS";
export const SET_DATA = "SET_DATA";
export const SET_LOADING = "SET_LOADING";
export const SET_TO_REMOVE = "SET_TO_REMOVE";
export const SET_TO_UPSERT = "SET_TO_UPSERT";
export const SET_TO_VIEW = "SET_TO_VIEW";
